'use strict';

if (!window.i18n) {
	window.i18n = {};
}

if (!window.i18n.languages) {
	window.i18n.languages = {};
}

window.i18n.languages['ms_MS'] = {
	optional:"Pilihan",
	needBet: "Masih perlu bertaruh:",
	needDeposit:"Masih perlu deposit:",
	agentCode : "Kod jemputan",
	tips_fail:"Tuntutan gagal",
	a_stauts: "Status aktif",
	activityDetails_hdjxz: "Aktiviti sedang berjalan",
	activityDetails_hdwks: "Aktiviti belum dimulakan",
	activityDetails_hdyjs: "Acara sudah selesai",
	a_time: `Masa aktiviti`,
	a_status: `Status aktif`,
	a_rule: `Peraturan ganjaran`,
	a_content: `Perincian Aktiviti`,


	gameCoin:"Mata wang permainan",
	register_chooseCurrency: "Pilih mata wang deposit",
	register_tips0:"*Perubahan mata wang tidak dibenarkan selepas pendaftaran",
	register_curInstruction:"Penerangan mata wang:",
	register_tips1:"1. Semasa memasuki permainan yang tidak menyokong mata wang semasa pengguna,Jumlah yang ditukar pada kadar pertukaran akan dibawa ke dalam permainan;",
	register_tips2:"2. Kaedah deposit / pengeluaran pengguna adalah dengan memaparkan sokongan mata wang semasa pengguna;",


	sendSuccess:"Dihantar dengan jayanya!",
	login_areaCode: 'kod negara',
	login_selectAreaCode: 'Pilih negara atau wilayah',
	new_maxVipLV: 'selamat berjaya! ! Anda kini berada di tahap tertinggi',
	currency_symbol : "RM",
	language : "BahasaMelayu",

	new_r_rate: 'Jumlah yang dibawa ke dalam permainan adalah jumlah setelah penukaran kadar pertukaran',
	new_r_rate1: 'kadar pertukaran：',
	new_r_money: 'Wang dalam permainan:',
	new_r_tips6: '*Harap maklum bahawa anda hanya dapat memasukkan bilangan bulat ketika berpindah ke permainan tiga pihak',
	new_r_tips7: 'Peringatan kadar pertukaran',
	new_r_tips8: 'Saya tahu',
	new_r_tips9: 'Anda sedang memasuki',
	new_r_game: "permainan",

	"ActivityNew": {
	"btn_lingqu": "Dapatkan sekarang",
	"btn_back": "Kembali",
	"toggle_zonghe": "Aktiviti yang komprehensif",
	},

	"SignIn": {
		"btnLingqu": "Terima",
	},

	"label_text": {
		"title": "Dapatkan ganjaran",
		"loading_msg": "Memuat turun pek sumber kemas kini untuk anda",
		"not_logged": "Tidak log masuk",
		"password": "Kata laluan:",
		"verify": "Kod pengesahan:",
		"verify_msg": "Sila masukkan kod pengesahan",
		"inPlease_enter_the": "Sila masukkan",
		"phone": "Telefon bimbit",
		"No": "Nombor",
		"determine": "Menentukan",
		"receive": "Terima",
		"Image_preview": "Pratonton avatar",
		"Install": "Install sekarang",
		"obtain": "Selamat berjaya",
		"check_update": "Memeriksa kemas kini ...",
		"real_name": "Nama sebenarnya",
		"tips": "Tahan permainan buruk, tolak permainan cetak rompak. Perhatikan perlindungan diri dan berhati-hatilah ditipu. Permainan sederhana memberi manfaat kepada otak, menikmati minuman permainan. Atur masa dengan",
		"tishi": "Segera",
		"no_data": "Tiada data",
		"queding": "Menentukan",
		"quxiao": "Membatalkan",
		"download_new_version": "Sila muat turun versi terkini aplikasi untuk menggunakan ciri ini",
		"online_kefu": "Perkhidmatan dalam talian",
		"save_account": "Simpan maklumat akaun",
	},

	"data_req_text": {
		"login_failure": "Log masuk telah tamat, sila log masuk sekali lagi",
	},

	"login_text": {
		"account_pro": "Nombor akaun tidak boleh kosong, sila isi!",
		"psw_pro": "Kata laluan tidak boleh kosong, sila isi!",
		"vfy_pro": "Kod pengesahan tidak boleh kosong, isikan!",
		"quick_login_fail": "Log masuk pantas gagal!",
		"account": "Nombor akaun:",
		"account_msg": "Sila masukkan akaun / nombor telefon",
		"paw_msg": "Sila masukkan kata laluan",
		"Remember_acc": "Ingat saya",
		"forget_paw": "Lupa kata laluan?",
		"no_acc": "Tiada akaun,",
		"go_reg": "Pergi ke Pendaftaran>",
		"confirm_login": "Sahkan log masuk",
		"quick_login": "Log Masuk Pantas",
		"confirm_register": "Sahkan pendaftaran",
		"register_cg": "Pendaftaran berjaya",
		"account_data": "Maklumat Akaun",
        "sfyz": "Pengesahihan",
        "sfyz_tip": "Pelanggan tersayang!Untuk melindungi keselamatan akaun anda, log masuk ini memerlukan pengesahan berikut untuk mencegah program jahat daripada log masuk secara automatik.",
        "bind_bank": "Sila masukkan kad bank terikat",
        "bind_alipay": "Sila masukkan Alipay terikat",
        "bank_card": "Kad bank:",
        "alipay": "Alipay:",
        "code": "Kod Pengesahan:",
        "enter_bank_card": "Sila masukkan nombor kad bank",
        "enter_alipay": "Sila masukkan nombor akaun Alipay",
        "enter_code": "Sila masukkan kod pengesahan",
	},

	"register_text": {
		"perfect_suc": "Lengkapkan maklumat dengan jayanya!",
		"perfect_err": "Data lengkap gagal!",
		"inp_data": "Sila masukkan maklumat terlebih dahulu!",
		"inp_email": "Sila masukkan e-mel anda",
		"inp_phone": "Sila masukkan nombor telefon",
		"inp_wx": "Sila masukkan ID WeChat",
		"inp_qq": "Sila masukkan nombor QQ",
		"email": "Peti mel:",
		"wx_No": "WeChat:",
		"qq_No": "Nombor QQ:",
		"phone": "Nombor telefon:",
		"user_name": "Nama pengguna:",
		"user_msg": "Masukkan akaun huruf atau nombor 6-12 digit",
		"user_pro": "kata laluan 6-12 huruf atau nombor atau simbol",
		"paw_pro": "Kata laluan adalah gabungan 6-12 digit dan huruf",
		"confirm_paw_pro": "Kata laluan pengesahan tidak boleh kosong, sila isi!",
		"paw_consistent": "Kata laluan dan kata laluan yang disahkan tidak konsisten, sila isi lagi!",
		"paw_msg": "Sila masukkan kata laluan dengan 6-12 huruf dan nombor",
		"confirm_msg": "Sila sahkan kata laluan sekali lagi",
		"phone_msg": "Sila masukkan kod pengesahan telefon",
		"con_paw": "Sahkan kata laluan:",
		"exi_acc": "Sudah mempunyai akaun,",
		"go_log": "Pergi ke log masuk>",
		"send_verify": "Hantar",
		"retry_verify": "Hantar semula",
		"phone_confirm": "Masukkan nombor telefon yang betul!",
		"register_suc": "Pendaftaran berjaya!",
		"user_not_mag": "Nama pengguna tidak boleh kosong, sila isi!",
		"No_null": "Nombor tidak boleh kosong, sila isi!",
		"correct_phone": "Masukkan nombor telefon yang betul!",
		"phone_vfy": "Kod pengesahan telefon tidak boleh kosong, sila isi!",
		"loss_account": "Untuk mengelakkan akaun hilang, sila simpan akaun",
		"account_change": "Akaun hanya boleh diubah satu kali, klik ubah suai",
		"please_tick": "Sila klik butang centang untuk mengesahkan kata laluan akaun!",
		"save_suc": "Berjaya disimpan!",
		"save_err": "Simpan gagal!Sila ambil tangkapan skrin secara manual!",

		"currency": "Mata Wang:",
		"language": "Bahasa:",

	},

	"datum_text": {
		"datum_title": "Hantar maklumat",
		"bank_card": "Nombor kad bank:",
		"inPlease_enter_the": "Sila masukkan ...",
		"input_datum": "Sila masukkan data terlebih dahulu",
		"update_img": "Muat naik gambar",
		"select_update_img": "Sila pilih gambar yang dimuat naik",
		"limit_type": "Hanya JPG, JPEG, PNG yang boleh dimuat naik",
		"msg_update_data": "Sila muat naik data terlebih dahulu",
		"mag_update_pic": "Sila muat naik gambar dalam format yang betul terlebih dahulu",
		"apply_succ": "Permohonan berjaya dihantar, sila tunggu semakan",
	},

	"task_text": {
		"activity": "Aktiviti",
		"task": "Tugas",
		"announcement": "Pengumuman",
		"sign": "Log masuk",
		"task_name": "Nama misi:",
		"task_detail": "Perincian tugas",
		"task_time": "Masa berkesan tugas:",
		"task_content": "Kandungan tugas:",
	},

	"customer_text": {
		"jump_whatsapp": "Akaun whatsapp berjaya disalin, minta pengalihan ke whatsapp",
		"jump_telegram": "Akaun telegram berjaya disalin, minta pengalihan ke telegram",
		"jump_Messenger": "Akaun Messenger berjaya disalin, minta pengalihan ke Messenger",
		"jump_Viber": "Akaun Viber berjaya disalin, minta pengalihan ke Viber",
		"no_whatsapp": "whatsapp tidak dipasang pada peranti anda",
		"no_telegram": "telegram tidak dipasang pada peranti anda",
		"no_Messenger": "Messenger tidak dipasang pada peranti anda",
		"no_Viber": "Viber tidak dipasang pada peranti anda",

		"contact_customer": "Hubungi Perkhidmatan Pelanggan",
		"not_ind_qq": "QQ tidak dipasang pada peranti anda",
		"jump_wx": "Akaun WeChat berjaya disalin, minta pengalihan ke WeChat",
		"not_ind_wx": "WeChat tidak dipasang pada peranti anda",
		"jump_mt": "Akaun perkhidmatan pelanggan MT berjaya disalin, minta pengalihan semula perkhidmatan pelanggan MT",
		"Online": "Perkhidmatan dalam talian",
		"QQ": "Perkhidmatan pelanggan QQ",
		"WECHAT": "Perkhidmatan Pelanggan WeChat",
		"MT": "Perkhidmatan pelanggan MT",
		"CJ": "Masalah biasa",
		"contact_online": "Hubungi Perkhidmatan Pelanggan",
		"copy_wx": "Salin ID WeChat",
		"copy_mt": "Salin nombor MT",
	},

	"msg_text": {
		"save_date": "Mesej disimpan sehingga satu bulan",
		"message": "Berita",
		"email": "Mel",
		"receive": "Menerima",
		"overdue": "Tamat",
		"not_delete": "Tidak dapat dipadamkan, sila kumpulkan ganjaran terlebih dahulu",
		"not_be_deleted": "Mel yang tidak dituntut tidak akan dihapuskan",
	},

	"basic_text": {
		"basic_title": "Maklumat asas",
		"account": "Nombor akaun:",
		"nickname": "Nama Panggilan:",
		"name": "Nama:",
		"com_title": "Maklumat komunikasi",
		"qq": "Q S:",
		"wx": "WeChat:",
		"phone": "Telefon bimbit:",
		"email": "Peti mel:",
	},

	"baes_text": {
		"unit": "Yuan",
		"view": "Lihat》",
		"yes": "Ya",
		"no": "Tidak",
		"update": "Kemas kini",
		"cancel": "Membatalkan",
		"mail_system": "Mel sistem",
		"connected": "Bersambung, harap bersabar ...",
		"coin": "Emas",
	},

	"pre_details_text": {
		"detail": "Isi semula maklumat",
		"lxkf": "Hubungi Perkhidmatan Pelanggan",
		"rkz": "Mendeposit ...",
		"copy": "Salinan",
		"order": "Nombor pesanan",
		"date": "Isi semula masa",
		"czType": "Kaedah mengisi semula",
		"transfer": "Pindahkan",
		"succ": "Kejayaan",
		"error": "Kegagalan",
		"audit": "Ditinjau",
		"czSucc": "Pengisian semula gagal",
		"copy_succ": "Salin berjaya",
		"order_num": "Nombor pesanan",
	},

	"USDT_text": {
		"second_step": "Langkah 2: Maklumat rantaian USDT",
		"url_name": "Nama rantai",
		"alipay": "Bayar dengan Ali-Pay",
		"url": "Alamat rantai ...",
	},

	"set_text": {
		"set_music": "Tetapan muzik",
		"switch_music": "Pertukaran muzik",
		"change_d_paw": "Ubah suai kata laluan masuk",
		"change_t_paw": "Ubah suai kata laluan pengeluaran",
		"version": "Versi terkini",
		"huidu": "Skala kelabu",
		"swi_test": "Beralih ke versi beta?",
		"swi_hui": "Adakah mahu beralih ke versi skala kelabu?",
		"old_paw_null": "Kata laluan lama tidak boleh kosong, sila isi!",
		"new_paw_null": "Kata laluan baru tidak boleh kosong, sila isi!",
		"old_paw_limit_length": "Kata laluan lama ialah 6-12 digit",
		"new_paw_limit_length": "Kata laluan baru adalah gabungan 6-12 digit dan huruf",
		"new_paw_limit": "Kata laluan lama mestilah 6 digit, sila isi lagi",
		"con_paw_null": "Kata laluan pengesahan tidak boleh kosong, sila isi!",
		"con_paw_consistent": "Kata laluan dan kata laluan yang disahkan tidak konsisten, sila isi lagi!",
		"new_old_paw_consistent": "Kata laluan baru tidak boleh sama dengan kata laluan lama, sila isi lagi!",
		"change_succ": "Tahniah, anda berjaya menukar kata laluan anda, sila log masuk lagi!",
		"tx_paw_null": "Kata laluan pengeluaran tidak boleh kosong, sila isi",
		"con_tx_paw": "Sahkan kata laluan pengeluaran tidak boleh kosong, sila isi",
		"tx_paw_consistent": "Kata laluan pengeluaran tidak sesuai dengan kata laluan pengesahan, sila sahkan",
		"tx_paw_limit": "Kata laluan pengeluaran mestilah 6 digit, sila isi lagi",
		"paw_change_succ": "Tahniah, anda berjaya menukar kata laluan anda",
		"latest_version": "Ini adalah versi terkini Aplikasi",
		"switch_server": "Tukar pelayan",
		"switch_language": "Tukar bahasa",
		"change_language_tips": "Bahasa beberapa halaman akan berlaku setelah memulakan semula aplikasi",
		"restart": "But semula",
	},

	"share_text": {
		"copy_wa": "Salin salin",
		"save_img": "Simpan Gambar",
		"share_py": "Kongsi kalangan rakan",
		"submit_audit": "Hantar semakan",
		"copy_succ": "Salin berjaya",
		"save_img_succ": "Simpan gambar dengan jayanya",
		"save_err": "Gagal menyimpan gambar. Sila pergi ke halaman tetapan telefon untuk membuka kebenaran aplikasi ini untuk menyimpan gambar",
		"share_go": "Kongsi ke:",
		"share_err_qq": "Perkongsian gagal, sila pasang atau periksa QQ dan cuba lagi",
		"share_err_wx": "Perkongsian gagal, pasang atau periksa WeChat dan cuba lagi",
		"share_err_wl": "Pengikatan gagal, sila periksa rangkaian dan cuba lagi",
		"shareIntroduce_title": "Kongsi tutorial",
		"inviteFriends": "Menjemput kawan-kawan",
	},

	"hot_text": {
		"dzyx": "Mengumpulkan permainan video popular global, semangat tidak berkurang, kadar kemenangan lebih tinggi. Sepuluh juta hadiah menanti anda menang!",
		"qbyx": "Kumpulkan permainan papan paling popular di dunia, populariti tidak berkurang, kadar kemenangannya lebih tinggi, dan anda akan memenangi puluhan juta hadiah!",
		"byyx": "Mengumpulkan permainan memancing yang paling popular di dunia, semangat tidak berkurang, kadar kemenangan lebih tinggi.",
		"rmqp": "Catur popular",
		"rmdz": "Elektronik Popular",
		"rmby": "Memancing popular",
		"ljyx": "Main sekarang",
	},

	"agent_text": {
		"my_id": "ID saya:",
		"under": "Komisen langsung semalam:",
		"offline": "Komisen untuk luar talian semalam:",
		"under_player": "Pemain langsung:",
		"day_new": "Ditambah semalam:",
		"offline_player": "Pemain luar talian:",
		"bind_wx": "Ikut ke WeChat",
		"share_rewards": "Berkongsi ganjaran:",
		"commission_ins": "Tarikh penyelesaian komisen adalah penyelesaian harian, berkongsi dengan rakan atau kalangan rakan boleh mendapat hadiah ganjaran!",
	},

	"vip_text": {
		"title": "VIP saya",
		"backToMe": "Kembali ke tambang",
		"me": "Saya",
		"my_level": "Tahap saya:",
		"current_code": "Jumlah pengekodan semasa:",
		"was_filed": "Jackpot Promosi",
		"was_filed_info": "Anda boleh menerima bonus apabila anda maju",
		"weeks_amounts": "Zhou Lijin",
		"weeks_amounts_info": "Pengedaran percuma setiap hari Isnin",
		"month_amounts": "Hadiah bulanan",
		"month_amounts_info": "Diagihkan tepat pada waktunya pada 1 setiap bulan",
		"wash_code": "Kod basuh",
		"wash_code_info": "Nisbah kod pencucian maksimum",
		"but_text": "Pergi sekarang",
		"get_error": "Gagal mendapatkan syiling emas, sila muatkan semula syiling emas itu lagi!",
		"amount_code": "Jumlah kod",
	},

	"xima_text": {
		"game_type": "Jenis permainan",
		"dm_total": "Jumlah pertaruhan yang berkesan",
		"proportion": "Nisbah kod pencucian maksimum",
		"xm_amount": "Jumlah kod basuh",
		"can_led_take": " Ada",
		"xm_total": "Jumlah mencuci",
	},

	"PlayerCenter": {
		"jbxx": "Maklumat asas",
		"zhmx": "Maklumat akaun",
		"zdlb": "Senarai pertaruhan",
		"my_vip": "VIP saya",
		"save": "Berjimat",
		"edit": "Mengedit",
		"note": "Kenyataan",
		"betting_record": "Rekod pertaruhan",
		"trading_hours": "Jam urus niaga",
		"trading_type": "Jenis Transaksi",
		"change_amount": "Perubahan jumlahnya",
		"balance": "Seimbang",
		"today": "Pada masa kini",
		"yesterday": "Semalam",
		"a_month": "Sebulan",
		"all": "Semua",
		"status": "Status perdagangan",
		"chess": "Catur",
		"send_time": "Masa pembayaran",
		"note_num": "Nombor pertaruhan permainan",
		"betting_amount": "Jumlah pertaruhan",
		"has_been": "Dianugerahkan",
		"gaming": "Platform permainan",

		"currencyType": "Tukar mata wang",
		"rate": "Kadar pertukaran",
	},

	"RechargeLayer": {
		"note": "Kenyataan",
		"often_play": "Jumlah pantas yang sering dimainkan oleh pemain",
		"between": "Sila masukkan jumlah antara 1 dan 100",
		"gift100": "100% percuma",
		"payment_account": "Menerima akaun",
		"payee": "Pembayar",
		"where": "Bank Akaun",
		"depositors": "Sila isi nama sebenar pendeposit",
		"note_info": "Maklumat komen",
		"step": "Langkah pertama: Imbas kod QR pembayaran dan isi semula",
		"step2": "Langkah 2: Isi maklumat cas anda dan serahkan cas semula",
		"session": "Perbualan terkini",
		"official": "Perakuan rasmi",
		"gift2": "2% percuma",
		"channel": "* Sila pilih saluran tambah nilai \ n * Sila periksa nilai tukar dengan teliti sebelum memilih saluran",
		"qr_code": "Simpan \ nSimpan \ nDua \ nDimensi \ nKod",
		"digital_currency": "Saluran pengisian semula mata wang digital 1",
		"step_1": "Langkah 1: Pilih jumlah USDT",
		"formula": "Formula pengiraan untuk pengisian semula ke jumlah akaun: 70.86 = 10.1234USDT * kadar pertukaran semasa 7 yuan",
		"step3": "Langkah 3: Berikan maklumat pengeluaran",
		"actual_account": "Jumlah sebenar USDT diterima",
		"poundage": "Bayaran pengendalian 0-50USDT",
		"instr": "* Sila isi dengan lengkap seperti yang ditunjukkan dalam gambar sebelah kiri! \ n * Sekiranya anda mengisi dengan tidak betul, anda tidak akan dapat tiba tepat waktu!",
		"not_account": "Caj belum tiba?",
		"rate": "Kadar pertukaran: 1USDT = 99 yuan",
		"prompt_info": "Maklumat segera",
		"czjl": "Isi semula rekod",
		"czjc": "Mengisi semula tutorial",
		"ljcz": "Isi semula sekarang",
		"czje": "Jumlah cas semula",
		"zfpz": "Baucar pembayaran",
		"save_code": "Simpan kod QR",
		"xuanchuan": "Ejen rasmi mengisi semula \ n jaminan reputasi mutlak",
		"usdt_address": "Alamat deposit USDT:",
		"syb": "Sebelumnya",
		"complete": "Melaksanakan",
		"usdt_num": "Isi semula jumlah USDT:",
		"go_recharge": "Pergi ke atas",
		"back": "Kembali",
		"creat_order": "Buat Pesanan",
		"real_usdt": "Jumlah sebenar USDT diterima",
		"sxf": "Yuran pengendalian",
		"date": "Masa",
		"state": "Status",
		"jine": "Jumlah",
		"detail": "Perincian",
		"rechargeCourse": "Mengisi semula tutorial",
		"rate2coin": "Kadar pertukaran: 1 syiling emas =",
		"currency_symbol": "RM",
		"currency_word": "RMB",
		"get_coins": "Syiling emas yang diterima:",
		"get_money": "Jumlah yang diterima:",
		"go_pay": "Salinan berjaya. Adakah anda mahu membayar dengan segera?",
		"pay_now": "Bayar segera",
		"pay_not_support": "Tidak dapat membuat pembayaran buat sementara waktu!",
	},

	"SettingLayer": {
		"bind_equi": "Mengikat peranti",
		"basic_info": "Maklumat asas",
		"account": "Nombor akaun:",
		"level": "Tahap:",
		"set_sound": "Tetapan bunyi",
		"music": "Muzik",
		"sound": "Kesan bunyi",
		"switch_music": "Pertukaran muzik",
		"song2": "Saya mesti suka ketika saya mati",
		"song1": "Lagu 1",
		"inp_landing_paw": "Sila masukkan kata laluan anda",
		"inp_old_paw": "Sila masukkan kata laluan lama",
		"old_paw": "Kata laluan lama:",
		"inp_new_paw": "Sila masukkan kata laluan baru",
		"new_paw": "Kata laluan baharu:",
		"con_new_paw": "Sahkan kata laluan baru",
		"con_paw": "Sahkan kata laluan:",
		"check_update": "Menyemak kemas kini",
		"determine": "Menentukan",
		"bind_shuom1": "* Setelah mengikat peranti, anda boleh menggunakan log masuk cepat untuk log masuk ke peranti terikat secara langsung.",
		"bind_shuom2": "* Dengan cepat log masuk untuk mendaftarkan akaun, peranti semasa terikat secara automatik.",
		"bind_shuom3": "* Setelah mengikat peranti, anda dapat mengesahkan identiti dan melepaskannya.",
		"bind_shuom4": "* Untuk mengesahkan identiti, anda perlu memasukkan kata laluan masuk akaun.",
		"bind_shuom5": "* Sila gunakan dengan berhati-hati!",
		"bind_shuom6": "Peranti semasa telah terikat",
		"bind_shuom7": "Peranti lain sudah terikat",
		"landing_paw": "Kata laluan log masuk:",
		"test": "Persekitaran ujian",
		"huidu": "Persekitaran skala kelabu",
		"standbyTest": "Persekitaran ujian alternatif",
		"mute_all": "Bisukan semua",
		"change_account": "Tukar akaun",
		"confirm_change": "Sahkan perubahan",
		"confirm_bind": "Mengikat peranti",
		"unbind_device": "Buka peranti",
		"unbind": "Terikat",
	},

	"Task": {
		"share_task": "Berkongsi tugas",
		"MG_electronic": "MG Elektronik",
		"cash": "Wang tunai",
		"complete": "Untuk menamatkan",
		"application": "Memohon",
		"refused": "Ditolak",
		"disclose_data": "Hantar maklumat",
		"submit": "Serahkan",
		"Audit_failure": "Kegagalan audit",
		"friends_account": "Hantar tangkapan skrin",
		"apply_reward": "Memohon pahala",
		"pic_limit": "Hanya JPG, JPEG, PNG yang boleh dimuat naik, tidak lebih dari 1 juta",
		"btn_choose": "Pilih",
		"update_pic": "Muat naik gambar:",
		"editTips": "Sila pilih gambar yang dimuat naik",
		"task_details": "Perincian tugas",
		"Task_details": "Butiran tugas:",
		"task_name": "Nama misi:",
		"task_state": "Penerangan tugas:",
		"share": "Kongsi",
		"task_progress": "Kemajuan tugas:",
		"know": "Saya tahu",
		"q_update_pic": "Sila muat naik gambar terlebih dahulu",
		"activit_Shut": "Aktiviti tugas ditutup",
		"Qbind_wx": "Sila ikatkan WeChat terlebih dahulu",
		"Application_success": "Permohonan berjaya, sila tunggu semakan",
		"Succ_application_Award": "Permohonan ganjaran berjaya",
		"task_ShutDown": "Tugas berkongsi ditutup",
	},

	"ThirdGamesListLayer": {
		"xsj": "Catur Dunia Baru",
		"tall_game": "1 permainan keseluruhan",
		"inp_game": "Sila masukkan nama permainan",
	},

	"TuiGuangLayer": {
		"title": "Agensi Promosi",
		"my_agent": "Ejen saya",
		"agent_recruit": "Pengambilan ejen",
		"agent_introduced": "Pengenalan ejen",
		"players_query": "Pertanyaan pemain",
		"results_query": "Pertanyaan prestasi",
		"rich_list": "Senarai kekayaan",
		"my_id": "ID saya:",
		"under": "Komisen langsung semalam:",
		"offline": "Komisen untuk luar talian semalam:",
		"under_player": "Pemain langsung:",
		"day_new": "Ditambah semalam:",
		"offline_player": "Pemain luar talian:",
		"share_rewards": "Berkongsi ganjaran:",
		"commission_ins": "Tarikh penyelesaian komisen adalah penyelesaian harian, berkongsi dengan rakan atau kalangan rakan boleh mendapat hadiah ganjaran!",
		"save_qr_code": "Simpan kod QR",
		"copy": "Salinan",
		"bind_wx": "Ikut ke WeChat",
		"Imm_receive": "Dapatkan sekarang",
		"share_detail": "Kongsi butiran",
		"get_record": "Rekod koleksi",
		"historyCom": "Jumlah komisen sejarah",
		"canReceive": "Komisen yang boleh diterima",
		"zhishu_renshu": "Bilangan laporan langsung:",
		"tall_bets_today": "Jumlah pertaruhan berkesan hari ini:",
		"inp_id": "Sila masukkan ID",
		"query": "Tanyakan",
		"reset": "Tetapkan semula",
		"bets_today": "Pertaruhan sah hari ini",
		"total_bets": "Jumlah pertaruhan berkesan",
		"directly_num": "Bilangan laporan langsung",
		"operation": "Beroperasi",
		"details": "Perincian >>",
		"date": "Tarikh",
		"under_new": "Ditambah secara langsung",
		"team_new": "Pasukan baru",
		"directly_under": "Rebat komisen langsung",
		"total_amount": "Jumlah rebat",
		"reward": "Ganjaran",
		"contact": "Hubungi tutor",
		"ranking": "Pangkat",
		"player_info": "Maklumat pemain",
		"rebate_month": "Rebat komisen bulan ini",
		"rewards_month": "Kongsi ganjaran pada bulan ini",
		"detailed_info": "Perincian",
		"zhuce_shijian": "Masa pendaftaran:",
		"jtyxtz": "Pertaruhan sah hari ini:",
		"tdrsxz": "Bilangan pasukan (baru):",
		"jrtdyxtz": "Pertaruhan sah pasukan hari ini:",
		"directly_num_new": "Bilangan laporan langsung (baru):",
		"zuoriyongjing": "Komisen semalam:",
		"commission_payable": "Komisen yang boleh ditarik balik:",
		"lishizongyong": "Jumlah komisen sejarah:",
		"zyxtz": "Jumlah pertaruhan berkesan:",
		"agent_commission": "Komisen agensi",
		"share_commission": "Komisen saham",
		"team_num": "Saiz pasukan",
		"not_directly_under": "Potongan harga tidak langsung",
		"account": "Nombor akaun",
		"between": "Hubungan",
		"effective_betting": "Jumlah pertaruhan / rebat yang berkesan",
		"ratio": "Nisbah rebat",
		"total": "Jumlah",
		"share": "Kongsi",
	},

	"WithdrawLayer": {
		"self_help": "Pengunduran layan diri",
		"withdrawal_record": "Rekod pengeluaran",
		"wallet_management": "Pengurusan dompet",
		"inp_withdrawal_amount": "Sila masukkan jumlah pengeluaran",
		"warm_prompt": "Petua",
		"current_need_adjust_amount": "Anda masih memerlukan aliran <color = # 00ff00> 0 </c> untuk mengeluarkan wang tunai",
		"current_need": "Masih perlu",
		"can_carry": "Mengalir air sebelum menarik",
		"adjust_amount": "Seret titik untuk menyesuaikan jumlah pengeluaran",
		"bank": "ICBC",
		"change_bank_card": "Tukar kad bank",
		"not_bind_card": "Anda belum mengikat kad bank anda, sila mengikat",
		"not_tixian_paw": "Anda belum menetapkan kata laluan penarikan, sila tetapkan kata laluan penarikan terlebih dahulu",
		"tixian_paw": "Tarik balik kata laluan",
		"set6num_paw": "Sila tetapkan kata laluan 6 digit",
		"confirm_password": "Sahkan kata laluan",
		"again_confirm_password": "Sila masukkan kata laluan sekali lagi untuk mengesahkan",
		"inp_tixian_paw": "Sila masukkan kata laluan pengeluaran",
		"topUp_failure": "Pengisian semula gagal",
		"bank_paragraph": "Pengeluaran bank",
		"add_card": "Tambahkan kad bank",
		"cardholder_name": "Sila masukkan nama pemegang kad",
		"cardholder": "Pemegang kad:",
		"card_code": "Nombor akaun kad bank:",
		"inp_bank_card_code": "Sila masukkan nombor kad bank",
		"inp_bank_address": "Sila masukkan alamat bank",
		"bank_address": "Alamat pembukaan akaun:",
		"bank_address_msg": "Petua: Pilih bank akaun dengan betul dan sebutkan nama sebenarnya. Akaun akan dipindahkan terus ke akaun semasa pembayaran. Untuk keselamatan dana anda, anda tidak dapat mengubahnya sesuka hati setelah",
		"choose_bank": "Pilih Bank:",
		"inp_aliPay_name": "Sila masukkan nama sebenar Alipay",
		"inp_aliPay_code": "Sila masukkan akaun Alipay",
		"name": "Nama:",
		"aliPay_account": "Akaun Alipay:",
		"aliPay_account_msg": "Petua: Pilih Alipay dengan betul, dan ia akan dipindahkan secara langsung ke akaun yang telah berubah semasa penyelesaian. Untuk keselamatan dana anda, anda tidak dapat mengubahnya sesuka hati setelah",
		"inp_tixian_dizhi": "Sila masukkan alamat pengeluaran",
		"rate": "Kadar pertukaran",
		"daozhangUSDT": "Jumlah USDT diterima",
		"confirm_tixian": "Sahkan pengeluaran",
		"max": "Maksimum",
		"confirm_submit": "Sahkan Penyerahan",
		"tixian_time": "Masa pengeluaran",
		"jine": "Jumlah",
		"state": "Status",
		"order_info": "Maklumat pesanan",
		"confirm_bind": "Tentukan mengikat",
		"confirm_select": "Sahkan pilihan",
		"select_bank_card": "Pilih kad bank",
		"bizhong_xuanze": "Pilihan mata wang:",
		"tixian_dizhi": "Alamat pengeluaran:",
		"more_than_0": "Jumlah pengeluaran harus lebih besar daripada 0",
	},

	"XimaLayer": {
		"title": "Kod basuh",
		"selfHelp_washing": "Kod mencuci sendiri",
		"xima_record": "Basuh rekod kod",
		"xima_proportion": "Nisbah kod basuh",
		"fishing_game": "Permainan memancing",
		"to_complete": "Untuk menamatkan",
		"receive": "Terima",
		"chess": "Catur",
		"fishing": "Memancing",
		"electronic": "Elektronik",
		"reality": "Orang sebenar",
		"sports": "Pendidikan Jasmani",
		"eSports": "Permainan",
		"lottery": "Loteri",
		"game": "Permainan",
		"key_get": "Koleksi satu klik",
		"get_time": "Masa pengumpulan",
		"damaliang": "Jumlah pertaruhan yang berkesan",
		"xima_amount": "Jumlah kod basuh",
		"details": "Perincian",
		"viewI": "Lihat >>",
		"xima_details": "Butiran mencuci kod",
		"heitao_chess": "Sekop",
		"chess_game": "Permainan papan",
		"sports_events": "Acara sukan",
		"electronic_game": "Permainan elektronik",
		"lottery_betting": "Pertaruhan loteri",
		"real_video": "Video langsung",
		"eSports_game": "Permainan e-sukan",
		"game_name": "Nama permainan",
		"click_details": "Klik untuk maklumat lanjut",
		"tianmei_chess": "Catur Tianmei",
		"detailsI": "Perincian >>",
		"xima_range": "Julat mencuci kod",
		"vip_level": "Tahap VIP",
		"tournament": "E-sukan",
		"lottery_game": "Permainan loteri",
	},

	"Signal": {
		"switch": "Tukar talian",
		"speed": "Garis pecutan",
		"choose": "Pilih garis",
		"reconnect": "Sambung semula",
		"helpful_hints": "Peringatan mesra: semakin rendah kelewatan, semakin baik rangkaian",
		"is_msg": "Ini adalah mesej",
		"in_test": "Memeriksa",
		"general": "Umum",
		"smooth": "Lancar",
		"speed1": "Kepantasan",
		"current_use": "Sedang digunakan",
	},

	"general": {
		"name": "Nama",
		"activity": "Aktiviti yang komprehensif",
		"xzsm": "Penerbit alamat, dapatkan alamat pemasangan terkini pada bila-bila masa.",
		"wszl": "Bahan lengkap",
		"qdcj": "Bonus log masuk",
		"xtyj": "Mel sistem",
		"xxzx": "Pusat Mesej",
		"bt": "Tajuk",
		"sj": "Masa",
		"nr": "Kandungan",
		"xx": "Berita",
		"dlq": "Yang belum selesai",
		"ylq": "Menerima",
		"ygq": "Tamat",
		"ready_all": "Semua dibaca",
		"del_all": "Memadam semua",
		"get_all": "Tuntut semua",
	},

	"EllipticalStage": {
		"musicNmae": "Untuk kemenangan",
	},

	"CheckHot": {
		"update_msg": "Kemas kini versi baru dikesan dan muat turun selesai untuk anda. Klik untuk menyelesaikan kemas kini!",
		"update": "Kemas kini",
		"lack_resources": "Kekurangan sumber seni",
		"kaiyuan_chess": "Catur Kaiyuan",
		"leyou_chess": "Le Tour Catur",
		"xinshijie_chess": "Catur Dunia Baru",
		"ag_electronic": "AG Elektronik",
		"pg_electronic": "PG Elektronik",
		"mg_electronic": "MG Elektronik",
	},

	"HallUI": {
		"copy_succ": "Salin berjaya",
		"moment_open": "Belum dibuka",
		"no_announcement": "Tiada kandungan pengumuman",
		"tmpled_err": "Ralat konfigurasi templat, sila hubungi perkhidmatan pelanggan",
		"game_maintain": "Permainan ini masih dalam penyelenggaraan",
		"game_loading": "Permainan sedang dimuat",
		"get_err": "Gagal mendapatkan syiling emas, sila muatkan semula syiling emas itu lagi!",
		"login": "Log masuk",
		"register": "Berdaftar",
		"copy_id": "Salin ID",
		"huodong": "Aktiviti",
		"task": "Tugas",
		"setting": "Sediakan",
		"remen": "Popular",
		"qipai": "Catur",
		"buyu": "Memancing",
		"zhenren": "Orang sebenar",
		"dianzi": "Elektronik",
		"tiyu": "Pendidikan Jasmani",
		"caipiao": "Loteri",
		"dianjing": "Permainan",
		"tuiguangdaili": "Agensi Promosi",
		"xima": "Kod basuh",
		"xiaoxi": "Berita",
		"kefu": "Khidmat Pelanggan",
		"xiufugongju": "Alat pembaikan",
		"gengduo": "Lebih banyak lagi",
		"qiandao": "Log masuk",
		"paihangbang": "Papan pendahulu",
		"gonggao": "Pengumuman",
		"tixian": "Menarik diri",
		"chongzhi": "Isi semula",
		"xianshilingqu": "Pengumpulan masa terhad",
		"remenyouxi": "Permainan teratas",
		"zuijingchangwan": "Baru dimainkan",
		"play_now": "Taruhan",
	},

	"BasicsJS": {
		"tall": "Dalam jumlah",
		"minGame": "Permainan kecil",
		"play_game": "Tidak ada permainan yang baru dimainkan",
		"editor_succ": "Edit berjaya",
		"yi_bind": "Terikat",
		"wu_bind": "Tidak terikat",
		"inp_amount": "Sila masukkan jumlah caj semula",
		"inp_correct_amount": "Sila masukkan jumlah pengisian semula yang betul",
		"no_login_yinshang": "Pedagang Bank Tidak Berdaftar",
		"gift": "Hadiah",
		"voucher_cannot_empty": "Baucar pembayaran tidak boleh kosong",
		"pic_loading": "Gambar sedang dimuat",
		"amount_between": "Jumlah antara",
		"card": "Kad",
		"note_info": "Isi maklumat komen, masuk ke akaun dengan lebih cepat",
		"credit_cord": "Menerima nombor kad",
		"rate": "Kadar pertukaran",
		"not_channel": "Saluran pengisian semula tidak ada, sila hubungi khidmat pelanggan",
		"select_amount": "Sila pilih jumlah pengisian semula",
		"confirm_cancellation_order": "Adakah anda pasti membatalkan pesanan",
		"been_submit": "Pesanan telah dihantar, sila tunggu dengan sabar",
		"Eventually_topUp_amount": "Isi semula terakhir ke jumlah akaun adalah",
		"current_rate": "Kadar pertukaran semasa",
		"Outstanding_orders": "Anda mempunyai pesanan yang belum selesai, sama ada untuk meneruskan",
		"Continue": "Teruskan",
		"Cancel_order": "Membatalkan pesanan",
		"bind_succ": "Ikat dengan jayanya",
		"inp_paw": "Sila masukkan kata laluan terlebih dahulu",
		"remove_bind_succ": "Berhenti berjaya",
		"first": "Pertama",
		"day": "Hari",
		"Sports_eSports": "Sukan E-sukan",
		"directly": "Langsung di bawah",
		"not_directly": "Tidak langsung di bawah",
		"amount_not_null": "Jumlah pengeluaran tidak boleh kosong, sila isi",
		"WithdrawalAmount": "Jumlah Pengeluaran",
		"Qbind": "Sila ikat terlebih dahulu",
		"moment_not_bind": "Anda tidak terikat pada masa ini",
		"QgoBind": "Sila pergi untuk mengikat",
		"replace": "Ganti",
		"between": "Antara",
		"request_submit": "Permintaan pengeluaran telah dihantar",
		"ContinueToCarry": "Terus menarik diri",
		"GiveUpWithdrawal": "Berhenti menarik diri",
		"Qxuanding": "Petua: Sila pilih dengan betul",
		"jiesuanshihou": "Ia akan dipindahkan secara langsung ke ini",
		"zhuanghaowanquan": "Nombor akaun, untuk keselamatan dana anda, tidak dapat diubah sesuka hati setelah mengikat. Sekiranya anda perlu mengubahnya, sila hubungi khidmat pelanggan.",
		"phoneNo": "Nombor telefon",
		"add": "Tambah ke",
		"updateTimeout": "Periksa habis masa kemas kini, pastikan rangkaian anda normal",
		"retry": "Cuba lagi",
		"err_retry": "Ralat memuat turun fail, sila cuba lagi",
		"err_check_network": "Rangkaian tidak berfungsi, sila pastikan sama ada rangkaian anda normal",
		"no_get_data": "Tiada kemas kini sumber, sila cuba sebentar lagi",
		"network_retry": "Rangkaian terputus, periksa apakah sambungan rangkaian anda normal",
		"Quit_game": "Keluar dari permainan",
		"ReturnHall": "Kembali ke lobi",
		"daozhangUSDT": "Jumlah USDT diterima",
	},
};